const Scenes = ({ scenes }: { scenes: any }) => {
  return (
    <div className="space-y-4">
      {scenes.map((scene: any) => (
        <div
          className="space-y-1 p-2 rounded-lg border border-[#000] border-opacity-30"
          key={scene.scene_number}
        >
          <h4 className="text-[#0D0D0D80] text-[13px] leading-[120%] tracking-[0%] font-medium font-grotesk">
            Scene {scene.scene_number}
          </h4>
          <p className="text-[#0D0D0D] text-[11px] leading-[120%] tracking-[0%]">
            {scene.description || "N/A"}
          </p>
        </div>
      ))}
    </div>
  );
};

export default Scenes;
